// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3119) return "static/chunks/3119-a038bcf87551e9d1.js";
	if (chunkId === 3859) return "static/chunks/3859-3fa953a1c614c17e.js";
	if (chunkId === 9617) return "static/chunks/9617-b296a8e715139c49.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2443":"421c87968564abcd","2823":"c642ebf67fce02b6","4654":"8dcca80d88728063","5192":"8581668d5e3d6d0f","5355":"0b841191694ee52f","8395":"4108f4b4e06a600c","9595":"9b048b13ec233730","9718":"74d0d6b3f67bef75"}[chunkId] + ".js";
};